// Function to toggle the popup display
function togglePopup() {
    let popupsection = document.querySelector('.price_request_section');
    let body = document.body;

    // Toggle display
    if (popupsection.style.display === 'block') {
        popupsection.style.display = 'none';
        body.style.overflow = 'auto'; // Allow scrolling
        removeContactPostedFromURL(); // Remove from URL
    } else {
        popupsection.style.display = 'block';
        body.style.overflow = 'hidden'; // Prevent scrolling
    }
}

// Function to check URL and display popup if needed
function checkURLAndDisplayPopup() {
    const urlParams = new URLSearchParams(window.location.search);
    const contactPosted = urlParams.get('contact_posted');

    // Check if contact_posted is true
    if (contactPosted === 'true') {
        let popupsection = document.querySelector('.price_request_section');
        popupsection.style.display = 'block'; // Show the popup
        document.body.style.overflow = 'hidden'; // Prevent scrolling
    }
}

// Function to remove contact_posted=true from the URL and reload the form
function removeContactPostedFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.delete('contact_posted');
    const newURL = window.location.pathname + '?' + urlParams.toString();
    window.history.replaceState({ path: newURL }, '', newURL);
    location.reload(); // Reload the page to refresh the form
}

// Event listener for the inquire button
document.querySelector('.Inquire-btn').addEventListener('click', togglePopup);

// Event listener for the close icon
document.querySelector('.request_close_icon').addEventListener('click', function() {
    let popupsection = document.querySelector('.price_request_section');
    popupsection.style.display = 'none'; // Hide the popup
    document.body.style.overflow = 'auto'; // Allow scrolling
    removeContactPostedFromURL(); // Remove from URL and reload
});

// Event listener for the overlay
document.querySelector('.request_overlay').addEventListener('click', function() {
    let popupsection = document.querySelector('.price_request_section');
    popupsection.style.display = 'none'; // Hide the popup
    document.body.style.overflow = 'auto'; // Allow scrolling
    removeContactPostedFromURL(); // Remove from URL and reload
});

// Check the URL on page load
checkURLAndDisplayPopup();
